import { useSelector, useDispatch } from 'react-redux'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import {
  isFilteringSelector,
  filterTermSelector,
  userGroupsWhereAdminSelector,
  hasMoreUserGroupsSelector
} from 'selectors/home_bar'

import Header from './header'
import Item from './item'
import MenuGroup from './menu_group'
import ShowMore from './show_more'

const UserGroupsList = ({ selectItem, canCreateNewGroups }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const userGroupsWhereAdmin = useSelector(userGroupsWhereAdminSelector)
  const hasMoreUserGroups = useSelector(hasMoreUserGroupsSelector)
  const showHeader = !isFiltering || userGroupsWhereAdmin.length > 0

  return (
    <MenuGroup data-component="scope-dropdown-user-group-list">
      {showHeader && (
        <Header
          scope="user_group"
          showNewLink={canCreateNewGroups}
        />
      )}
      {userGroupsWhereAdmin.map(({ id, name, ...item }) => (
        <Item
          key={id}
          itemId={id}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          onClick={() => selectItem('user_group', id)}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreUserGroups && <ShowMore onClick={() => dispatch(loadMoreData('user_groups'))} />}
    </MenuGroup>
  )
}

export default UserGroupsList
